import type { Period } from '@/types/date';
import type { SelectItem } from '@/types/ui/selectItem';

export enum FilterType {
  // Date Range Filters
  SINGLE_DATE = 'singleDate',
  DATE_RANGE = 'dateRange',
  COMPARISON_PERIOD = 'comparisonPeriod',
  // General Filters
  COUNTRY = 'country',
  TERRITORY = 'territory',
  STATE_PROVINCE = 'stateProvince',
  TA = 'ta',
  OTHER_SPECIALTY = 'otherSpecialty',
  INDICATION = 'indications',
  TA_INDICATIONS = 'taIndications',
  PRODUCTS = 'products',
  TAE_LEVELS = 'taeLevels',
  CLASSIFICATION_LEVELS = 'classificationLevels',
  HCP_PROFESSION = 'hcpProfession',
  HCP_TYPE_OF_PRACTICE = 'hcpTypeOfPractice',
  OPTHTALMOLOGY_PERSONAS = 'ophtalmologyPersonas',
  ADOPTION_RATING = 'adoptionRating',
  POTENTIAL_RATING = 'potentialRating',
  // Scientific Activities Filters
  TOPIC = 'topic',
  CONGRESS = 'congress',
  PUBLICATION = 'publication',
  CLINICAL_TRIAL = 'clinicalTrial',
  SOCIAL_MEDIA = 'socialMedia',
  GUIDELINE = 'guideline',
  TRIAL_SPONSOR = 'trialSponsor',
  SCIENTIFIC_ORGANIZATION = 'scientificOrganization',
  VALUE_AND_MOTIVATION = 'valueAndMotivation',
  FAIR_MARKET_VALUE_RATING = 'fairMarketValueRating',
  ROCHE_INTERACTION_LADDER = 'rocheInteractionLadder',
  PREFERRED_CHANNEL_RATING = 'preferredChannelRating',
  SOURCE_SYSTEM = 'sourceSystem',
  // channel-specific filters
  ONE_TO_ONE_CHANNELS = 'oneToOne',
  FIELD_FORCE = 'fieldForce',
  ROCHE_EMPLOYEE = 'rocheEmployee',
  INTERACTION_TYPE = 'type',
  PROMO = 'promo',
  EMAIL_CHANNEL = 'emailChannel',
  EMAIL_CAMPAIGN = 'emailCampaign',
  EMAIL_TOPIC = 'emailTopic',
  WEBSITE_PORTAL = 'websitePortal',
  EVENT_TYPE = 'eventType',
  EVENT_NAME = 'eventName',
  INTERACTION_INDICATION = 'interactionIndication',
  INTERACTION_PRODUCT = 'interactionProduct',
  CHANNEL = 'channel',
  CONSENT_LEVEL = 'consentLevel',
  DIRECT_MAIL = 'directMail',
  PRODUCT_MESSAGE_NAME = 'productMessageName',
  PRODUCT_MESSAGE_GROUP = 'productMessageGroup',
  // cnet-specific filters
  NPS_SCORE = 'npsScore',
  TRUST_REPUTATION = 'trustReputation',
  INTERACTION_TYPE_ALL_CHANNELS = 'interactionTypeAllChannels',
  PRODUCT_LOCAL = 'productLocal',
  // hcp engagement filters
  SECONDARY_SPECIALTY = 'secondarySpecialty',
  AREA_OF_INTEREST = 'areaOfInterest',
  LOCAL_SOURCE = 'localSource',
  HCP_X_TWITTER_ACCOUNT = 'hcpXTwitterAccount',
  HCP_WITH_LINKED_IN_ACCOUNT = 'hcpWithLinkedInAccount',
  HCP_WITH_BLUESKY_ACCOUNT = 'hcpWithBlueskyAccount',
  // aggregated consent filters
  CONSENT_TOPIC_NAME = 'topicName',
  CONSENT_TIER = 'tier',
  CONSENT_PPOC = 'ppoc',
  // partner score filters
  PARTNER_SCORE_YEAR_QUARTER = 'yearQuarter',
  PARTNER_SCORE_SURVEY_TITLE = 'surveyTitle',

  COMPETITOR_YEAR_QUARTER = 'competitorYearQuarter',
  COMPETITOR_COMPETITOR = 'competitor',
  COMPETITOR_SURVEY_TITLE = 'competitorSurveyTitle',
  // insights filters
  INSIGHT_INDICATION = 'indication',
  INSIGHT_PRODUCT = 'product',
  INSIGHT_TAG = 'tag',
  INSIGHT_FIELD_FORCE_CODE = 'fieldForceCode',
  INSIGHT_EMPLOYEE_TYPE = 'employeeType',
  INSIGHT_EMPLOYEE_NAME = 'employeeName',
  INSIGHT_ASSIGNMENT = 'insightAssignment',
  // HCO characteristics filters
  HCO_COUNTRY = 'hcoCountry',
  HCO_STATE_PROVINCE = 'hcoStateProvince',
  HCO_TYPE = 'hcoType',
  HCO_SPECIALTY = 'hcoSpecialty',
  HCO_PRIVATE_PUBLIC_STATUS = 'hcoPrivatePublicStatus',
  HCO_SOURCE_SYSTEM = 'hcoSourceSystem',
  HCO_ACCOUNT_PLANNING_IN_PROGRESS = 'hcoAccountPlanningInProgress',
  HCO_ACCOUNT_PLANNING_COMPLETED = 'hcoAccountPlanningCompleted',
  // Sales filters
  SALES_PRODUCT_GROUP = 'salesProductGroup',
  SALES_PRESCRIPTION_TYPE = 'salesPrescriptionType',
  SALES_TERRITORY = 'salesTerritory',
  SALES_BRICK = 'salesBrick',
  SALES_MY_TERRITORY = 'salesMyTerritory',
}

export type FilterValue = Period | Date | string[] | string | SelectItem[] | SelectItem | number | boolean | null;
